// Site offer (snippets/site-offer.liquid, docs/theme/COUPON-PRICE.md). Loaded only while an offer runs:
// - Apply code: stores the code on the session (/discount/CODE); Shopify's checkout takes it off once the
//   order qualifies.
// - Amounts outside the shop currency: Shopify converts a code's minimum and fixed amount at the market's
//   exchange rate, which Liquid can't see, so snippets/site-offer-money.liquid leaves them empty for here.
// - End date: pages are cached, so hide the offer once it ends even on a page rendered before that.
(function () {
    const endsAt = Number(document.currentScript?.dataset.ends) || 0;
    const storageKey = 'site-offer-applied';
    const currency = window.Shopify?.currency;
    const rate = Number(currency?.rate) || 0;

    // Card colour swatches re-price the card in theme.js; keep the price after the code in step (same rounding
    // as snippets/site-offer-price.liquid). Amount codes have no per-item price, so there is nothing to change.
    window.SiteOffer = {
        cardPrice(card, cents) {
            card.querySelectorAll('.site-offer[data-offer-percent]').forEach((line) => {
                const percent = Number(line.dataset.offerPercent);
                const html = Shopify.formatMoney(cents - Math.round(cents * percent / 100), window.money_format);
                line.querySelectorAll('.site-offer__price').forEach((price) => { price.innerHTML = html; });
            });
        }
    };

    function expire() {
        document.documentElement.classList.add('site-offer-expired');
    }

    if (endsAt) {
        const left = endsAt - Date.now();
        if (left <= 0) {
            expire();
            return;
        }
        // setTimeout overflows past ~24.8 days; a page is never open that long.
        if (left < 2147483647) setTimeout(expire, left);
    }

    function fillMoney() {
        if (!rate || typeof Shopify.formatMoney !== 'function') return;
        // Whole units: a minimum rounds up (never shows less than the real one), an amount off rounds down.
        const format = (window.money_format || '{{amount}}').replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/,
            (match, comma) => comma ? '{{amount_no_decimals_with_comma_separator}}' : '{{amount_no_decimals}}');

        document.querySelectorAll('[data-offer-money]:empty').forEach((element) => {
            const units = Number(element.dataset.offerMoney) / 100 * rate;
            const whole = element.dataset.offerRound === 'down' ? Math.floor(units) : Math.ceil(units);
            element.innerHTML = Shopify.formatMoney(whole * 100, format);
            element.closest('.js-offer-pending')?.classList.remove('js-offer-pending');
        });
    }

    function appliedCode() {
        try {
            return sessionStorage.getItem(storageKey);
        } catch (error) {
            return null;
        }
    }

    function markApplied() {
        const code = appliedCode();
        if (!code) return;
        document.querySelectorAll('[data-offer-apply]:not([disabled])').forEach((button) => {
            if (button.dataset.offerApply !== code) return;
            button.disabled = true;
            button.textContent = button.dataset.appliedText;
        });
    }

    function refresh() {
        fillMoney();
        markApplied();
    }

    document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-offer-apply]');
        if (!button || button.disabled) return;

        const code = button.dataset.offerApply;
        button.disabled = true;
        // redirect=/cart.js keeps the response small (the default redirect is the home page).
        fetch(`${window.routes?.root || ''}/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart.js')}`)
            .then((response) => {
                if (!response.ok) throw new Error(`discount ${response.status}`);
                try {
                    sessionStorage.setItem(storageKey, code);
                } catch (error) {
                    // Private mode: the code is still applied, it just isn't remembered across pages.
                }
                button.textContent = button.dataset.appliedText;
                markApplied();
            })
            .catch(() => {
                button.disabled = false;
                button.textContent = button.dataset.errorText;
            });
    });

    // Prices are re-rendered on variant change, quick view and AJAX card loads; fill those too.
    let queued = false;
    new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
            queued = false;
            refresh();
        });
    }).observe(document.body, { childList: true, subtree: true });

    refresh();
})();
